import React from 'react'
import { useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Tag } from 'primereact/tag'
import { mockSubscriptions, mockClients, mockProjects } from '../../../mocks'
import { Subscription } from '../../../types/entities'
import { subscriptionStatusLabel, subscriptionStatusSeverity } from '../utils/subscriptionHelpers'

const SubscriptionsListPage: React.FC = () => {
  const navigate = useNavigate()

  const mrr = mockSubscriptions
    .filter((s) => s.status === 'active')
    .reduce((sum, s) => sum + s.monthlyPrice, 0)

  const clientTemplate = (sub: Subscription) => {
    const client = mockClients.find((c) => c.id === sub.clientId)
    return client?.name ?? '–'
  }

  const projectsTemplate = (sub: Subscription) => {
    const names = sub.projectIds
      .map((pid) => mockProjects.find((p) => p.id === pid)?.name)
      .filter(Boolean)
    return names.join(', ') || '–'
  }

  const priceTemplate = (sub: Subscription) =>
    `R$ ${sub.monthlyPrice.toLocaleString('pt-BR')}/mês`

  const statusTemplate = (sub: Subscription) => (
    <Tag value={subscriptionStatusLabel(sub.status)} severity={subscriptionStatusSeverity(sub.status)} />
  )

  const renewalTemplate = (sub: Subscription) =>
    new Date(sub.renewalDate).toLocaleDateString('pt-BR')

  const actionsTemplate = (sub: Subscription) => (
    <Button
      icon='pi pi-eye'
      text
      severity='secondary'
      tooltip='Ver detalhes'
      onClick={() => navigate(`/dashboard/assinaturas/${sub.id}`)}
    />
  )

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '1.5rem' }}>
        <div>
          <h2 style={{ margin: 0 }}>Assinaturas</h2>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--text-color-secondary)' }}>
            {mockSubscriptions.length} assinaturas · MRR:{' '}
            <strong style={{ color: 'var(--primary-color)' }}>R$ {mrr.toLocaleString('pt-BR')}</strong>
          </p>
        </div>
      </div>

      <DataTable
        value={mockSubscriptions}
        paginator
        rows={10}
        emptyMessage='Nenhuma assinatura encontrada.'
        rowHover
        onRowClick={(e) => navigate(`/dashboard/assinaturas/${(e.data as Subscription).id}`)}
        style={{ cursor: 'pointer' }}
      >
        <Column header='Cliente' body={clientTemplate} sortable sortField='clientId' />
        <Column field='planName' header='Plano' sortable />
        <Column header='Aplicativos' body={projectsTemplate} />
        <Column header='Valor' body={priceTemplate} sortable sortField='monthlyPrice' />
        <Column header='Renovação' body={renewalTemplate} sortable sortField='renewalDate' />
        <Column header='Status' body={statusTemplate} sortable sortField='status' />
        <Column header='' body={actionsTemplate} style={{ width: '60px', textAlign: 'center' }} />
      </DataTable>
    </div>
  )
}

export default SubscriptionsListPage
